import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Turn Messages `}<br />{`Into ToDos`}</h1>
    <p>{`Right-click a word or phrase in a message you received in Franz Messenger and quickly turn it into an item on your to-do list. It's as simple as that.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      